import React, { Component } from 'react';
// import echarts from 'echarts/lib/echarts';
import * as echarts from 'echarts';
import { observer } from 'mobx-react';
import { toJS } from 'mobx';
import RFBluetoothInstance from '../../../../native-interact/RFBluetooth';
// 引入折线图
// import 'echarts/lib/chart/line';
// import 'echarts/lib/component/tooltip';
// import 'echarts/lib/component/title';
// import 'echarts/lib/component/legend';
// import 'echarts/lib/component/grid';
import Toast from '../../../../components/toast/Toast';

const RADAR_BASE_16 = [1996, 1929, 1356, 597, 324, 204, 131, 59, 33, 2, 0, 11, 1, 4, 3, 7];
const RADAR_BASE_32 = [2002, 3190, 3043, 1343, 243, 192, 164, 129, 68, 23, 12, 11, 5, 2, 1, 1, 2, 2, 2, 2, 3, 3, 3, 4, 5, 5, 4, 5, 5, 5, 6, 6];

class RadarChart extends Component {
  constructor(props) {
    super(props);

    this.chartDom = React.createRef();
    this.chart = null;
  }

  componentDidMount() {
    setTimeout(() => {
      const radarBase = this.props.geoStore.radarBase;
      this.initChart();

      // 如果雷达基值已经从日志中获取，则直接用
      if (radarBase.length > 0) {
        this.setData(toJS(radarBase));
      } else {
        this.getRadar();
      }
    }, 300);
  }

  getRadar() {
    this.chart.showLoading();
    RFBluetoothInstance.sendCommand('park base', {
      name: '查询当前车位雷达基值',
      expect: 'imsemi'
    }).then((res) => {
      const data = res.match(/^imsemi base:{(.*)}/)[1]
        .trim()
        .split(/\s+/);
      this.setData(data);
      this.chart.hideLoading();
    }).catch(() => {
      Toast.fail('获取雷达基值错误，请重试');
    });
  }

  getOptions(data = []) {
    const count = data.length === 32 ? 32 : 16;
    return {
      title: {
        text: ''
      },
      tooltip: {
        trigger: 'axis'
      },
      color: ['pink', '#2f4554', '#61a0a8', '#d48265', '#91c7ae', '#749f83', '#ca8622', '#bda29a', '#6e7074', '#546570', '#c4ccd3'],
      legend: {
        data: ['参考值', '当前雷达基值']
      },
      grid: {
        top: '14%',
        left: '3%',
        right: '4%',
        bottom: '3%',
        containLabel: true
      },
      xAxis: {
        type: 'category',
        boundaryGap: false,
        data: Array(count).fill(0).map((item, index) => (`k${index}`))
      },
      yAxis: {
        type: 'value'
      },
      series: [
        {
          name: '参考值',
          type: 'line',
          data: count === 32 ? RADAR_BASE_32 : RADAR_BASE_16
        },
        {
          name: '当前雷达基值',
          type: 'line',
          data
        }
      ]
    };
  }

  setData(data = []) {
    this.chart.setOption(this.getOptions(data));
  }

  initChart() {
    this.chart = echarts.init(this.chartDom.current);
    this.setData();
  }

  render() {
    return (
      <div>
        <div className="tip">
          <p style={{ fontSize: '12px', marginBottom: 10, lineHeight: '20px' }}>
          雷达基值判断标准参考：
            <br />
          K2往后没有明显尖峰且k值平滑下降趋于0
          </p>
        </div>
        <div className="chart" ref={this.chartDom} style={{ width: '100%', height: '200px' }}></div>
      </div>
    );
  }
}

export default observer(RadarChart);
